import { $, api, appState } from './app-state';
import { newController } from './app';
import { disconnect, startSession } from './session';
import { guestIdentity } from '../shared/guest-identity';
import { bindSiteDialogs } from '../shared/ui/site-dialogs';
import { readSessionMode } from '../shared/ui/session-mode';

export function bindGuest(): void {
  bindSiteDialogs();
  const form = $('guest-form') as HTMLFormElement;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const field = $('guest-code') as HTMLInputElement;
    const password = $('guest-password') as HTMLInputElement;
    const code = field.value.replace(/[\s-]/g, '');
    const error = $('guest-error');
    if (!appState.connectionPreflightCanConnect) {
      error.textContent = '当前网络或浏览器环境暂时无法连接，请先完成连接前检查。';
      return;
    }
    if (!/^\d{9}$/.test(code)) {
      error.textContent = '请输入对方客户端显示的九位设备码'; field.setAttribute('aria-invalid', 'true'); field.focus(); return;
    }
    field.removeAttribute('aria-invalid'); error.textContent = '';
    const button = $('guest-connect') as HTMLButtonElement;
    const previousLabel = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = '连接中…';
    let sessionStarted = false;
    try {
      const key = guestIdentity(code);
      const accessMode = readSessionMode('guest-mode-picker');
      const guestPassword = password.value;
      const connect = async (): Promise<void> => {
        startSession(accessMode, connect);
        sessionStarted = true;
        // 本机 ID 只用于增强自连接校验，不应阻塞连接页和等待层的展示。
        // 信令层在没有 ID 时仍会通过设备码/会话身份完成校验。
        let localId: string | null = '';
        try {
          localId = await api.getLocalDeviceId();
        } catch {
          // 浏览器无法探测本机客户端时，继续走正常的免登录连接流程。
        }
        // 用户可能在本机 ID 返回前取消连接，或已经开始了另一条连接。
        // 此时不要把旧请求的控制器重新挂回当前会话。
        if (!sessionStarted || $('view-session').classList.contains('hidden') || appState.controller) return;
        const controller = newController();
        appState.controller = controller;
        await controller.connectGuest(code, guestPassword, key, localId || undefined, accessMode);
      };
      void connect().catch(() => {
        if (sessionStarted) disconnect('暂时无法开始连接，请重试或更换浏览器。');
        else error.textContent = '无法开始连接，请重试或更换浏览器';
      });
      password.value = '';
    } catch {
      if (sessionStarted) {
        disconnect('暂时无法开始连接，请重试或更换浏览器。');
      } else {
        error.textContent = '无法开始连接，请重试或更换浏览器';
      }
    }
    finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = previousLabel;
    }
  });
}
